import React from "react";
import FileUploader from "../../../components/FileUploader/FileUploader";

interface DocumentsSectionProps {
  userData: any;
  errors: any;
  onInputChange: (e: any, name: string) => void;
}

const DocumentsSection: React.FC<DocumentsSectionProps> = ({ userData, errors, onInputChange }) => {
  return (
    <div className="form-section mb-0">
      <div className="section-title">
        <i className="pi pi-file"></i>
        <h3>Upload Documents</h3>
      </div>

      <div className="grid p-fluid formgrid form-max-heigth">
        {/* T4 Files Upload - Multiple files */}
        <div className="field col-12 md:col-4">
          <label htmlFor="t4_file">
            T4 Of All The Jobs You Worked <span className="required"></span>
          </label>
          <FileUploader name="t4_file" onInputChange={onInputChange} multiple={true} maxSize={10} value={userData.t4_file} />
          <small className="p-invalid-txt">{errors["t4_file"]}</small>
        </div>

        {/* T2202a File Upload - Single file */}
        <div className="field col-12 md:col-4">
          <label htmlFor="t2202a_file">
            Upload T2202A File <span className="required"></span>
          </label>
          <FileUploader name="t2202a_file" onInputChange={onInputChange} multiple={false} maxSize={10} value={userData.t2202a_file} />
          <small className="p-invalid-txt">{errors["t2202a_file"]}</small>
        </div>

        {/* T4A Files Upload - Multiple files */}
        <div className="field col-12 md:col-4">
          <label htmlFor="t4a_file">
            T4A Of All The Jobs You Worked <span className="required"></span>
          </label>
          <FileUploader name="t4a_file" onInputChange={onInputChange} multiple={true} maxSize={10} value={userData.t4a_file} />
          <small className="p-invalid-txt">{errors["t4a_file"]}</small>
        </div>

        {/* T5007 File Upload - Single file */}
        <div className="field col-12 md:col-4">
          <label htmlFor="t5007_file">
            Upload T5007 File <span className="required"></span>
          </label>
          <FileUploader name="t5007_file" onInputChange={onInputChange} multiple={false} maxSize={10} value={userData.t5007_file} />
          <small className="p-invalid-txt">{errors["t5007_file"]}</small>
        </div>

        {/* T5008 File Upload - Single file */}
        <div className="field col-12 md:col-4">
          <label htmlFor="t5008_file">
            Upload T5008 File <span className="required"></span>
          </label>
          <FileUploader name="t5008_file" onInputChange={onInputChange} multiple={false} maxSize={10} value={userData.t5008_file} />
          <small className="p-invalid-txt">{errors["t5008_file"]}</small>
        </div>

        {/* T5 File Upload - Single file */}
        <div className="field col-12 md:col-4">
          <label htmlFor="t5_file">
            Upload T5 File <span className="required"></span>
          </label>
          <FileUploader name="t5_file" onInputChange={onInputChange} multiple={false} maxSize={10} value={userData.t5_file} />
          <small className="p-invalid-txt">{errors["t5_file"]}</small>
        </div>

        {/* uber file - Multiple files */}
        <div className="field col-12 md:col-4">
          <label htmlFor="uber_file">
            Upload Uber Eats / DoorDash / SkipTheDishes <span className="required"></span>
          </label>
          <FileUploader name="uber_file" onInputChange={onInputChange} multiple={true} maxSize={10} value={userData.uber_file} />
          <small className="p-invalid-txt">{errors["uber_file"]}</small>
        </div>

        {/* Other File - Multiple files */}
        <div className="field col-12 md:col-4">
          <label htmlFor="other_file">
            Upload Other File <span className="required"></span>
          </label>
          <FileUploader name="other_file" onInputChange={onInputChange} multiple={true} maxSize={10} value={userData.other_file} />
          <small className="p-invalid-txt">{errors["other_file"]}</small>
        </div>

        {/* Document for Sign - Single file */}

        {/* <div className="field col-12 md:col-4">
          <label htmlFor="document_sign">
            Upload Document To Sign <span className="required"></span>
          </label>
          <FileUploader name="document_sign" onInputChange={onInputChange} multiple={false} maxSize={10} value={userData.document_sign} />
          <small className="p-invalid-txt">{errors["document_sign"]}</small>
        </div> */}
      </div>
    </div>
  );
};

export default DocumentsSection;
